import { motion } from "framer-motion";

export const Logo = ({ size = 32, animate = false }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
    <circle cx="16" cy="16" r="13" fill="none" stroke="#e3ba73" strokeOpacity=".45" strokeWidth="1.2" />
    <motion.path
      d="M5 16c2.2-8 4.4-8 6.4 0s3.6 6 5.2 0 2.6-3 3.8 0H27"
      fill="none"
      stroke="#e3ba73"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      initial={animate ? { pathLength: 0 } : false}
      animate={{ pathLength: 1 }}
      transition={{ duration: 1.6, ease: [0.65, 0, 0.35, 1] }}
    />
  </svg>
);

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);
